<template>
  <div class="accout-login">
    <a-form
      :form="form"
      @submit.prevent="loginHandle"
    >
      <a-form-item
        label=""
      >
        <a-input
          v-decorator="decorators.mobile"
          :placeholder="mobilePlace"
        />
      </a-form-item>
      <a-form-item
        label=""
        class="password-box"
      >
        <a-input
          v-decorator="decorators.checkcode"
          :placeholder="telValidPlace"
          class="password-input"
        />
        <get-code
          class="find-pwd-link"
          type="7"
          :is-disabled="isDisabled"
          :mobile="form.getFieldValue('mobile')"
        />
      </a-form-item>
      <a-form-item
        label=""
      >
        <!-- <a-input
          v-decorator="decorators.newpwd"
          type="password"
          placeholder="请输入新密码"
        /> -->
        <a-popover
          title=""
          trigger="focus"
          overlay-class-name="input-tip-tip-box"
        >
          <template slot="content">
            <p>{{ $t('message["633"]') }}</p>
          </template>
          <a-input
            v-decorator="decorators.newpwd"
            type="password"
            :placeholder="newPwdPlaceholder"
          />
        </a-popover>
      </a-form-item>
      <a-form-item
        label=""
      >
        <a-input
          v-decorator="[
            'renewpassword',
            {rules: [
              {required: true, message: pwdNewPlaceholder},
              {validator: checkPassword}
            ]}
          ]"
          type="password"
          :placeholder="pwdNewPlaceholder"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
        >
          {{ $t('message["1161"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
// import { fetchApi } from '@/common'
import { mapState, mapActions } from 'vuex'
import GetCode from '@/components/pc/GetCode'
export default {
  'name': 'TelFindPwd',
  components: {
    GetCode
  },
  data () {
    return {
      isDisabled: false,
      getCodeUrl2: '',
      formLayout: 'horizontal'
    }
  },
  computed: {
    ...mapState('account/modify', ['submitting', 'decorators']),
    telValidPlace () {
      return this.$t('message["803"]')
    },
    mobilePlace () {
      return this.$t('message["800"]')
    },
    newPwdPlaceholder () {
      return this.$t('message["816"]')
    },
    pwdNewPlaceholder () {
      return this.$t('message["891"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('account/modify', ['']),
    loginHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, { type: 1 })
          this.$emit('submitForm', obj, this.form)
        }
      })
    },
    // 校验二次输入的密码是否一致
    checkPassword (rule, value, callback) {
      const { getFieldValue } = this.form
      if (value !== getFieldValue('newpassword')) {
        callback(new Error(this.$t('message["607"]')))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="scss" >

.accout-login {
  .login-btn {
    display: block;
    width: 100%;
  }

  .password-box {
    position: relative;

    .find-pwd-link {
      position: absolute;
      right: 0;

      button {
      background: none;
      border: 0;
      color: #5077aa;
      padding: 0;
    }
    }
  }
}
</style>
